import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import { Link } from "react-router-dom";
import {
  Button,
  Flex,
  Input,
  PaginationProps,
  Select,
  SelectProps,
  Table,
  TableColumnsType,
  notification,
  Image,
  Checkbox,
} from "antd";
import {
  ArrowSquareDown,
  Crown,
  DocumentDownload,
  Home2,
  SearchZoomIn1,
} from "iconsax-react";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import LockModal from "../../components/Modal/LockModal";
import { mixGetV1, mixPostV1 } from "../../services/mixin";
import * as XLSX from "xlsx";
import { fallbackAvatar, IMAGE_URL } from "../../env";
import "./Bandit.scss";

type LabelRender = SelectProps["labelRender"];

const customSelectedLabel: LabelRender = (props) => {
  const { label } = props;

  if (label) {
    return (
      <Flex align="center" gap={8}>
        <Crown size={20} variant="Bulk" style={{ minWidth: 20 }} />
        <span>
          Role (<span className="text-active">{label}</span>)
        </span>
      </Flex>
    );
  }
  return (
    <Flex align="center" gap={8}>
      <Crown size={20} variant="Bulk" style={{ minWidth: 20 }} />
      <span>Role</span>
    </Flex>
  );
};

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

// CHECK ROLE = 'USER'

const Bandit: React.FC = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const permission = user.permission;
  const memberRole = permission
    ? permission.find((item: any) => item.function_id === 3)
    : null;

  const [selectedItem, setSelectedItem] = useState<any>();
  const [showBanPopup, setShowBanPopup] = useState(false);
  const [selectedCustomerIds, setSelectedCustomerIds] = useState<React.Key[]>(
    [],
  );
  const [unbanLoading, setUnbanLoading] = useState(false);

  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "error" = "success",
    message = "Updated!",
  ) => {
    api[type]({
      message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  // State cho table
  const [items0, setItems0] = useState<{
    list: Array<{ customer_id: string | number; [key: string]: any }>;
    total: number;
    total_bandit: number;
  }>({
    list: [],
    total: 0,
    total_bandit: 0,
  });
  const [tableLoading0, setTableLoading0] = useState(false);

  const [params0, setParams0] = useState<{
    customer_type: number;
    limit: number;
    page_number: number;
    searchKey?: string;
    roleSearch?: string;
    levelSearch?: string;
    sortBy?: string;
    sortType?: string;
  }>({
    customer_type: 2,
    limit: 10,
    page_number: 1,
  });

  // Get roles and levels
  const [roles, setRoles] = useState([] as any);

  const getUserRoles = async () => {
    const res = await mixGetV1("/api/webAdmin/gComboRoleCustoomer.php", {});
    if (res.status === 1) {
      const result: any = [];
      res.data.map((item: any) =>
        result.push({
          ...item,
          value: item.role_id,
          label: item.role_name,
        }),
      );
      setRoles(result);
    }
  };

  useEffect(() => {
    getUserRoles();
  }, []);

  let isFetching0 = false;
  const getItems0 = async () => {
    if (isFetching0) return;
    isFetching0 = true;
    setTableLoading0(true);
    const result: any = [];

    try {
      const res = await mixPostV1(
        "/api/webAdmin/gListBanditCustomerByStore.php",
        params0,
      );
      isFetching0 = false;

      if (res.status === 1) {
        res.data.map((item: any, index: number) => {
          result.push({
            ...item,
            customer_id: item.app_id,
            key: index,
            appId: item.app_id,
            name: item.customer_name,
            phone: item.phone_number,
            avatar: item.avatar || "/images/avatar.png",
            time_bandit: item.time_bandit,
            statusLock: item.is_locked,
            hand_register: item.hand_register,
            is_bandit: item.is_bandit,
          });
        });
        setItems0({
          ...items0,
          list: result,
          total: res.total,
          total_bandit: res.total_bandit,
        });
        setTableLoading0(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getItems0();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params0]);

  const onPageChange0 = (page: number) => {
    setParams0({
      ...params0,
      page_number: page,
    });
  };

  const onTableChange0 = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: any,
  ) => {
    let sortBy = "";
    let sortType = "";

    if (sorter) {
      const { field, order } = sorter;
      sortType = order === "descend" ? "DESC" : "ASC";
      sortBy = field;

      if (!order) {
        sortType = "";
        sortBy = "";
      }
    }

    setParams0({
      ...params0,
      sortType,
      sortBy,
      page_number: pagination.current,
      limit: pagination.pageSize,
    });
  };

  const handleUnbandit = async () => {
    if (selectedCustomerIds.length === 0) return;
    setUnbanLoading(true);
    setShowBanPopup(true);
  };

  // Search & Filter
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const onSearch = (query: string) => {
    setParams0({
      ...params0,
      page_number: 1,
      searchKey: query,
    });
  };

  const onEnter = (e: any) => {
    onSearch(e.target.value);
  };

  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value);
    }, 250);
    setSearchTimeout(timeout);
  };

  const onRoleChange = (value: any) => {
    if (value) {
      setParams0({
        ...params0,
        page_number: 1,
        roleSearch: value,
      });
    } else {
      setParams0({
        ...params0,
        page_number: 1,
        roleSearch: "",
      });
    }
  };

  // Export Excel
  const [exportLoading, setExportLoading] = useState(false);

  const formattedDataExcel0 = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        "App ID": item.app_id,
        "Customer name": item.customer_name,
        "Phone number": item.phone_number,
        Time: item.time_joint,
        Level: item.level.toString(),
      };
    });
    exportExcel(formattedData, "Bandit list");
  };

  const exportExcel = (
    convertData: any,
    nameExcel = "Bandit list",
  ): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${nameExcel}.xlsx`);
      return true;
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false;
    }
  };

  const getItemsByExcel = async () => {
    setExportLoading(true);
    const customParams = {
      ...params0,
      page_number: 1,
      limit: 10000,
    };

    try {
      const res = await mixPostV1(
        "/api/webAdmin/gListAllDistinctCustomerOfStore.php",
        customParams,
      );

      if (res.status) {
        if (res.data.length > 0) {
          formattedDataExcel0(res.data);
          setExportLoading(false);
        } else {
          setExportLoading(false);
          openNotification("error", "There is no data to export!");
        }
      } else {
        setExportLoading(false);
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      setExportLoading(false);
      openNotification("error", "Oops, something went wrong!");
    }
  };

  const columns0: TableColumnsType = [
    {
      title: (
        <Flex align="center" gap={8}>
          <Checkbox
            checked={
              items0.list.length > 0 &&
              items0.list.every((item) =>
                selectedCustomerIds.includes(item.customer_id),
              )
            }
            indeterminate={
              items0.list.some((item) =>
                selectedCustomerIds.includes(item.customer_id),
              ) &&
              !items0.list.every((item) =>
                selectedCustomerIds.includes(item.customer_id),
              )
            }
            onChange={(e) => {
              if (e.target.checked) {
                const allPageIds = items0.list.map((item) => item.customer_id);
                const combined = Array.from(
                  new Set([...selectedCustomerIds, ...allPageIds]),
                );
                setSelectedCustomerIds(combined);
              } else {
                const pageIds = items0.list.map((item) => item.customer_id);
                setSelectedCustomerIds(
                  selectedCustomerIds.filter(
                    (id) => !pageIds.includes(id as string | number),
                  ),
                );
              }
            }}
          />
          <span>Unbanned</span>
        </Flex>
      ),
      key: "actions",
      align: "center",
      className: "actions-sticky actions-sticky--left",
      render: (text, record) => (
        <Checkbox
          checked={selectedCustomerIds.includes(record.customer_id)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedCustomerIds([
                ...selectedCustomerIds,
                record.customer_id,
              ]);
            } else {
              setSelectedCustomerIds(
                selectedCustomerIds.filter((id) => id !== record.customer_id),
              );
            }
          }}
        />
      ),
    },
    {
      title: "No.",
      key: "stt",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) =>
        (params0.page_number - 1) * params0.limit + index + 1,
    },
    {
      title: "App ID",
      dataIndex: "appId",
      key: "appId",
      render: (text, record, index) => (
        <div
          className={`${
            Number(record.check_in_limit) > 0 ? "text-warning" : ""
          }`}
        >
          {record.app_id}
        </div>
      ),
    },
    {
      title: "Customer name",
      dataIndex: "name",
      key: "name",
      render: (text, record, index) => (
        <div
          className={`${
            Number(record.check_in_limit) > 0 ? "text-warning" : ""
          }`}
        >
          {record.name}
        </div>
      ),
    },
    {
      title: "Member Face",
      dataIndex: "face",
      key: "face",
      render: (text, record, index) => (
        <Flex align="center" gap={12}>
          <Image
            height={40}
            width={40}
            src={`${IMAGE_URL}${record.avatar}`}
            alt={record.name}
            preview={{
              src: `${IMAGE_URL}${record.avatar}`,
            }}
            fallback={fallbackAvatar}
            style={{
              borderRadius: "50%",
              overflow: "hidden",
              objectFit: "cover",
            }}
          />
          <span>{text}</span>
        </Flex>
      ),
    },
    {
      title: "Palm Registration",
      dataIndex: "handCheckin",
      key: "hand_register",
      render: (text, record, index) => (
        <Flex align="center" gap={12}>
          <Image
            height={40}
            width={40}
            src={`${IMAGE_URL}${record.hand_register}`}
            alt={record.name}
            preview={{
              src: `${IMAGE_URL}${record.hand_register}`,
            }}
            fallback={fallbackAvatar}
            style={{
              borderRadius: "50%",
              overflow: "hidden",
              objectFit: "cover",
            }}
          />
          <span>{text}</span>
        </Flex>
      ),
    },
    {
      title: "Phone number",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Time",
      dataIndex: "time_bandit",
      key: "time_bandit",
      render: (text, record) => <>{record.time_bandit}</>,
    },
  ];

  return (
    <>
      {contextHolder}

      <Layout contentClassName="member-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Banned" },
          ]}
          title="Banned"
          description=""
        />

        <div className="table-filter-block">
          <Input
            placeholder="Search by name, appid"
            prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
            className="rs-input w-349 grid-area-search"
            allowClear
            onPressEnter={(e) => onEnter(e)}
            onChange={(e) => onChange(e)}
          />
          <Select
            defaultValue={""}
            options={roles}
            placeholder="Role"
            popupMatchSelectWidth={false}
            allowClear={params0.roleSearch !== ""}
            suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
            className="rs-select w-186 grid-area-role"
            labelRender={customSelectedLabel}
            onChange={onRoleChange}
          />

          <Button
            icon={<DocumentDownload size={20} variant="Bulk" />}
            className="rs-button grid-area-export"
            loading={exportLoading}
            onClick={getItemsByExcel}
          >
            Export
          </Button>

          {selectedCustomerIds.length > 0 && (
            <Button
              type="primary"
              danger
              loading={unbanLoading}
              onClick={handleUnbandit}
              style={{ marginLeft: 12 }}
            >
              Unbandit ({selectedCustomerIds.length})
            </Button>
          )}
        </div>

        <Table
          columns={columns0}
          dataSource={items0.list}
          className="rs-table table-text-nowrap t-table-member"
          loading={tableLoading0}
          scroll={{
            x: true,
          }}
          showSorterTooltip={false}
          tableLayout="fixed"
          pagination={{
            current: params0.page_number,
            pageSize: params0.limit,
            position: ["bottomCenter"],
            showSizeChanger: true,
            showTitle: false,
            total: items0.total,
            itemRender: customPrevNext,
            onChange: (e) => onPageChange0(e),
          }}
          onChange={onTableChange0}
        />

        <LockModal
          isShow={showBanPopup}
          content={`Are you sure you want to lift the ban on these members?`}
          message="Member updated!"
          apiUrl="/api/webAdmin/unbanditCustomerById.php"
          param={{
            listCustomer: JSON.stringify(selectedCustomerIds),
          }}
          type="unban"
          onModalClose={() => setShowBanPopup(false)}
          onModalSubmit={() => {
            getItems0();
            setShowBanPopup(false);
            setUnbanLoading(false);
            setSelectedCustomerIds([]);
          }}
        />
      </Layout>
    </>
  );
};

export default Bandit;

